(function() {
	/**
	 * View Model
	 * @param {object} rawData - The Kentico Kontent Data Object
	 * @returns {object} The View-Model
	 */
	WebBaseAprovLV.Utils.getKKViewModel = function(kkModel) {
		var linkedItemsMap = {};
		var viewModelBuilder = function(kkModelRoot, element) {
			if (typeof element === 'object') {
				var newViewModel = {};
				if (((element.system || {}).codename || '').length) {
					// circular reference detection/prevention
					if (linkedItemsMap[element.system.codename]) {
						linkedItemsMap[element.system.codename].count++;
					} else {
						linkedItemsMap[element.system.codename] = {
							count: 0
						};
					}
					if (linkedItemsMap[element.system.codename]) {
						if (linkedItemsMap[element.system.codename].count > 10) {
							// max depth reached, return
							return linkedItemsMap[element.system.codename].data || null;
						}
						if (linkedItemsMap[element.system.codename].data) {
							return linkedItemsMap[element.system.codename].data;
						}
					}
				}
				Object.keys(element.elements || {}).forEach(function(v) {
					var curElement = element.elements[v] || {};
					if (curElement['type'] === 'modular_content') {
						(curElement.value || []).forEach(function(tsiv) {
							if (typeof newViewModel[v] === 'undefined') {
								newViewModel[v] = [];
							}
							if (!linkedItemsMap[tsiv]) {
								linkedItemsMap[tsiv] = {
									count: 0
								};
							}
							if (!linkedItemsMap[tsiv].data && kkModelRoot.modular_content[tsiv]) {
								linkedItemsMap[tsiv].data = viewModelBuilder(kkModelRoot, kkModelRoot.modular_content[tsiv]);
							}
							if (linkedItemsMap[tsiv].data) {
								newViewModel[v].push(linkedItemsMap[tsiv].data);
							}
						});
					} else if (curElement['type'] === 'rich_text') {
						newViewModel[v] = (function(item) {
							var text = item.value || '';
							var links = Object.keys(item.links || []);
							var modular = item.modular_content || [];
							if (modular.length) {
								modular.forEach(function(key) {
									var module = kkModelRoot.modular_content[key] || {};
									var codename = (module.system || {}).codename || '';
									var elements = module.elements || {};
									var replacement = '';
									var downloads;
									if (codename.length) {
										if (elements.html) {
											replacement = elements.html.value || '';
										}
										if (elements.downloads) {
											downloads = Object.keys(elements.downloads.value || {}).map(function(download) {
												var className = WebBaseAprovLV.Utils.getMimetypeClassName(download.type || '');
												var size = download.size || 0;
												var unit = 'B';
												if (size > 1000) {
													size = size / 1000;
													unit = 'KB';
													if (size > 1000) {
														size = size / 1000;
														unit = 'MB';
													}
													size = Math.round(size);
												}
												return '<li class="' + className + '"><a href="' + (download.url || '') + '">' + (download.description ? download.description : (download.name || className)) + ' (' + size + ' ' + unit + ')</a></li>';
											});
											if (downloads.length) {
												replacement = '<ul class="download_list">' + downloads.join('') + '</ul>';
											}
										}
										text = text.replace(new RegExp('<object[^>]*data-codename="' + codename + '"[^>]*></object>', 'igm'), replacement);
									}
								});
							}
							if (links.length) {
								// remove empty hrefs, replace data-item-id with href and replace keys with urls
								text = text.replace(/\s+href=(''|"")/igm, '').replace(/data-item-id=/igm, 'href=');
								links.forEach(function(key, i) {
									var url = '/' + WebBaseAprovLV.lang + '/' + ((item.links[key] || {}).url_slug || '');
									text = text.replace(new RegExp(key, 'igm'), url);
								});
							}
							return text;
						})(curElement);
					} else {
						newViewModel[v] = curElement.value;
					}
				});
				Object.keys(element.system || {}).forEach(function(v) {
					var curElement = element.system[v] || {};
					if (curElement['type'] === 'news_container') {
						(curElement.value || []).forEach(function(tsiv) {
							if (typeof newViewModel[v] === 'undefined') {
								newViewModel[v] = [];
							}
							if (!linkedItemsMap[tsiv]) {
								linkedItemsMap[tsiv] = {
									count: 0
								};
							}
							if (!linkedItemsMap[tsiv].data && kkModelRoot.modular_content[tsiv]) {
								linkedItemsMap[tsiv].data = viewModelBuilder(kkModelRoot, kkModelRoot.modular_content[tsiv]);
							}
							if (linkedItemsMap[tsiv].data) {
								newViewModel[v].push(linkedItemsMap[tsiv].data);
							}
						});
					} else {
						newViewModel['system_' + v] = curElement;
					}
				});
				return newViewModel;
			}
			return null;
		};
		if (((kkModel || {}).items || []).length) {	// caution: assume array
			return kkModel.items.map(function(item) {
				return viewModelBuilder(kkModel, item);
			}).filter(function(item) {	// filter undefined/null
				return !!item;
			});
		} else {
			if ((kkModel || {}).item) {
				return viewModelBuilder(kkModel, kkModel.item);
			}
		}
		return {};
	};
})();
